import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import { withValidation } from '../../validations';
import type { LangSDKProps, LangSDK } from './types';

const langSDKFactory: CorvidSDKPropsFactory<LangSDKProps, LangSDK> = ({
  setProps,
  props,
}) => ({
  get lang() {
    return props.lang;
  },

  set lang(_lang) {
    setProps({
      lang: _lang,
    });
  },
});

export const createLangSDK = withValidation(langSDKFactory, {
  type: ['object'],
  properties: {
    lang: {
      type: ['string'],
    },
  },
});
